import { apiService } from "@/services/auth";
import { defineStore } from "pinia";
import app from "@/main";
import { redirects } from "@/plugins/constrains";
import { criptografar } from "@/plugins/encript";
import { useToast } from "@/plugins/toast";
import i18next from "i18next";
import moment from "moment";
import { nextTick } from "@vue/composition-api";
export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: "",
    userId: "",
    name: "",
    status: "",
    email: "",
    image: "",
    tema: "",
    idioma: "",
    csrf: "",
    lastSendEmail: { time: "", email: "" },
    url_back: "",
  }),
  actions: {
    async gerarCSRF() {
      try {
        this.status = "LOADING";
        const dataCSRF = await apiService.csrf(process.env.VUE_APP_APPLICATION);
        this.setCSRF(dataCSRF.csfr);
        this.status = "";
        return true;
      } catch (error) {
        this.status = "ERROR";
        useToast(i18next.t("toast.register.error"), { type: "error" });
        console.log(error);
        return false;
      }
    },
    setCSRF(csrf: string) {
      this.csrf = csrf;
    },
    async validLogin() {
      try {
        this.status = "LOADING";

        await apiService.validToken();
        this.status = "";
        return true;
      } catch (error) {
        this.status = "ERROR";
        this.clean();
        return false;
        // error.response.data.message
        // useToast("Email ou senha incorretos.", { type: TYPE.ERROR });
      }
    },
    
    async login(email: string, senha: string) {
      try {
        this.status = "LOADING";

        const data = await apiService.login({ email, senha }, this.csrf);
        this.email = email;
        this.token = data.token;
        this.userId = data.user._id;
        this.name = data.user.nome;
        this.image = data.user.imagemUrl;
        this.idioma = data.user.idioma;
        this.tema = data.user.tema;
        this.status = "";
        this.redirectTo(data.url_retorno);
      } catch (error) {
        this.status = "ERROR";
        console.log(error);
        useToast(i18next.t("toast.login.error"), { type: "error" });
        // error.response.data.message
        // useToast("Email ou senha incorretos.", { type: TYPE.ERROR });
      }
    },
    async getUser() {
      try {
        this.status = "LOADING";
        const data = await apiService.user();
        this.name = data.nome;
        this.image = data.imagemUrl;
        this.idioma = data.idioma;
        this.tema = data.tema;
        this.status = "";
      } catch (error) {
        this.status = "ERROR";
        console.log(error);
        // useToast(i18next.t("toast.login.error"), { type: "error" });
      }
    },

    async recoveryPassword(userEmail?: string) {
      try {
        this.status = "LOADING-PASSWORD";
        const sendedEmail = userEmail || this.email;
        const now = moment();
        const last = moment(this.lastSendEmail.time);
        const mom = now.diff(last);
        this.lastSendEmail.time = now.format();
        this.lastSendEmail.email = sendedEmail;
        if (
          this.lastSendEmail.time &&
          this.lastSendEmail.email === sendedEmail &&
          moment.duration(mom).minutes() < 5
        ) {
          useToast(i18next.t("toast.sendEmail.timeout"), { type: "error" });
          this.status = "";
          return;
        }
        await apiService.sendEmail({ email: sendedEmail });
        this.status = "";
        useToast(i18next.t("toast.sendEmail.save"));
      } catch (error) {
        this.status = "ERROR";
        console.log(error);
        useToast(i18next.t("toast.sendEmail.error"), { type: "error" });
      }
    },
    async newPassword(payload: any) {
      try {
        this.status = "LOADING";
        await apiService.changePassword(payload.password, payload.token);
        this.status = "";
        useToast(i18next.t("toast.newPassword.save"));
        this.logout();
      } catch (error) {
        this.status = "ERROR";
        console.log(error);
        useToast(i18next.t("toast.newPassword.error"), { type: "error" });
      }
    },
    async editAccount(payload: any) {
      try {
        this.status = "LOADING";
        await apiService.update(payload);
        this.email = payload.email;
        this.name = payload.nome;
        this.idioma = payload.idioma;
        this.tema = payload.tema;
        this.status = "";
        useToast(i18next.t("toast.editUser.save"));
      } catch (error) {
        this.status = "ERROR";
        console.log(error);
        useToast(i18next.t("toast.editUser.error"), { type: "error" });
      }
    },
    redirectTo(url_retorno: string) {
      nextTick(() => {
        this.status = "LOADING";
      });
      if (url_retorno === process.env.VUE_APP_APPLICATION) {
        app.$router.push({ name: "home" });
      } else {
        const allLinks = redirects as any;
        if (allLinks[url_retorno]) {
          const data = {
            userId: this.userId,
            token: this.token,
          };
          const URLparams = new URLSearchParams({
            data: criptografar(JSON.stringify(data)),
          });
          window.location.replace(
            allLinks[url_retorno] + "/pos-login" + "?" + URLparams.toString()
          );
        } else {
          app.$router.push({ name: "home" });
        }
      }
      this.status = "";
    },
    async register(nome: string, email: string, senha: string) {
      try {
        const csrf = await this.gerarCSRF();
        if (!csrf) throw new Error("CSRF");
        this.status = "LOADING";
        await apiService.register({ nome, email, senha }, this.csrf);
        // useToast(data.message);
        this.status = "";
        useToast(i18next.t("toast.register.save"));
        app.$router.push({ name: "login", query: app.$route.query });
      } catch (error) {
        this.status = "ERROR";
        if ((error as any).message !== "CSRF")
          useToast(i18next.t("toast.register.error"), { type: "error" });
        // if (error?.response?.data?.message) {
        //   useToast(error.response.data.message, { type: TYPE.ERROR });
        // } else {
        //   useToast("Ocorreu um erro ao criar a conta", { type: TYPE.ERROR });
        // }
      }
    },
    async uploadImg(image: any) {
      try {
        this.status = "LOADING";
        const formData = new FormData();
        formData.append("imagem", image);
        const data = await apiService.uploadImage(formData, this.token);
        this.image = data.imagemUrl;
        useToast(i18next.t("toast.image.save"));
        this.status = "";
        return true;
      } catch (error) {
        this.status = "ERROR";
        useToast(i18next.t("toast.image.error"), { type: "error" });
        console.log(error);
      }
    },
    clean() {
      this.$reset();
    },
    logout() {
      this.$reset();
      // useBoardStore().$reset();
      if (app.$route.name !== "login")
        app.$router.push({ name: "login", query: app.$route.query });
    },
  },
  getters: {
    isLogged: (state) => !!state.token,
    loading: (state) => state.status === "LOADING",
    loadingEmail: (state) => state.status === "LOADING-EMAIL",
  },
  persist: {
    key: "store-auth",
  },
});
